import * as Yup from 'yup';

export const validateModel = Yup.object().shape({
  nombre: Yup.string()
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/, 'El nombre solo debe contener letras')
    .required('Indique su nombre'),
  apellido: Yup.string()
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/, 'El apellido solo debe contener letras')
    .required('Indique su apellido'),
  tipoDocumento: Yup.string().required('Indique su tipo de documento'),
  numero: Yup.string()
    .required('Indique el número de documento')
    .when('tipoDocumento', {
      is: '0', // DNI
      then: (schema) =>
        schema
          .matches(/^[0-9]+$/, 'El DNI solo debe contener números')
          .min(7, 'El DNI debe tener entre 7 y 8 dígitos')
          .max(8, 'El DNI debe tener entre 7 y 8 dígitos'),
      otherwise: (schema) =>
        schema
          .matches(/^[a-zA-Z0-9]+$/, 'El Pasaporte solo debe contener letras y números')
          .min(6, 'El Pasaporte debe tener entre 6 y 20 caracteres')
          .max(20, 'El Pasaporte debe tener entre 6 y 20 caracteres'),
    }),
  email: Yup.string().email('Email inválido').required('Indique su correo electrónico'),
  tipoCobertura: Yup.string().required('Seleccione al menos una opción disponible'),
  nombreAseguradora: Yup.string().when('tipoCobertura', {
    is: 'Obra social/Prepaga',
    then: (schema) => schema.required('Indique el nombre de la aseguradora'),
    otherwise: (schema) => schema.notRequired(),
  }),
  planCobertura: Yup.string().when('tipoCobertura', {
    is: 'Obra social/Prepaga',
    then: (schema) => schema.required('Indique el plan de cobertura'),
    otherwise: (schema) => schema.notRequired(),
  }),
  tipoAtencion: Yup.string().required('Seleccione al menos una opción disponible'),
  estudio: Yup.string().required('Describa el estudio que necesita'),
  credencialCobertura: Yup.mixed().when('tipoCobertura', {
    is: 'Obra social/Prepaga',
    then: (schema) => schema.test('min-1', 'Adjunte al menos 1 archivo', (val) => val && val.length >= 1),
    otherwise: (schema) => schema.notRequired(),
  }),
  ordenMedica: Yup.mixed().test('min-1', 'Adjunte al menos 1 archivo', (val) => val && val.length >= 1),
});
